import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import FlagsFilterUI from "../ui/FlagsFilterUI.vue";
import FlagsFilterBadge from "../ui/badges/FlagsFilterBadge.vue";

export default class FlagsFilter implements EventFilter {
  constructor(
    public readonly flagIds: number[],
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = FlagsFilterBadge;

  static readonly UI = FlagsFilterUI;

  getEventFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_FLAG_ID,
        value: {
          value: this.flagIds,
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
